<div class="modal-header">
  <label class="col-form-label" style="font-weight: bold">Nuevo proveedor</label>
  <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close" aria-label="Close" (click)="cerrar()"
    tabindex="13">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12">
      <button tabindex="22" type="button" class="btn btn-rounded btn-info m-b-15" (click)="guardarProveedor()">
        <i class="fa fa-save"></i> Guardar
      </button>
      <button (keydown.tab)="onNexFocus('Insert')" tabindex="23" type="button"
        class="btn btn-rounded btn-warning m-b-15" (click)="cancelarInsercion()">
        <i class="fa fa-times-circle"></i> Cancelar
      </button>

      <div class="card">
        <div class="card-body">
          <div [hidden]="vista !== 1">
            <ngb-tabset>
              <ngb-tab title="Proveedor">
                <ng-template ngbTabContent>
                  <div class="card-body">
                    <button class="btn btn-outline-dark" routerLinkActive="active" (click)="importarDatosSunat()"
                      id="btnImportar">
                      <img src="./assets/img/Sunat.ico" style="width: 16px; height: 16px; margin-left: -0.5rem" />
                      Importar de SUNAT
                    </button>

                    <button class="btn btn-outline-dark" routerLinkActive="active" (click)="importarDatosDNI()"
                      id="btnImportar">
                      <i class="far fa-address-card"></i> Importar DNI
                    </button>

                    <hr />
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Tipo de persona:
                          </label>
                          <div class="col-sm-2">
                            <select
                              class="col-sm-12 focus-input input_border focus-input input_border tsiSelect select_border"
                              (change)="
                                onSelectTipoPersonaIns($event.target.value)
                              " id="codtpe" name="codtpe" [(ngModel)]="objProveedor.codtpe" #selectInsertar
                              tabindex="1">
                              <option *ngFor="let lst of tipopersona" value="{{ lst.codtpe }}">
                                {{ lst.destpe }}
                              </option>
                            </select>
                          </div>
                          <span style="
                              color: red;
                              font: sans-serif;
                              margin-left: -17px;
                            ">(*)</span>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Tipo de identidad:
                          </label>
                          <div class="col-sm-3">
                            <select
                              class="col-sm-12 focus-input input_border focus-input input_border select_border tsiSelect"
                              id="tident" name="tident" (change)="
                                onSelectTipoIdentidadIns($event.target.value)
                              " [(ngModel)]="objProveedor.tident" tabindex="2">
                              <option *ngFor="let tipdoci of identidades" value="{{ tipdoci.tident }}">
                                {{ tipdoci.descri }}
                              </option>
                            </select>
                          </div>
                          <span style="
                              color: red;
                              font: sans-serif;
                              margin-left: -17px;
                            ">(*)</span>
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2" style="margin-left: -17px">Doc.
                            de identidad:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.dident" (keyup)="oneKeyupIdentidad($event)"
                              name="objProveedor.dident" #dident
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              (blur)="onBlurDocIdentidad()" [maxlength]="tamanoidentidad" tabindex="5" />
                          </div>
                          <span style="
                              color: red;
                              font: sans-serif;
                              margin-left: -17px;
                            ">(*)</span>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Código:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="disable_codigo" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.codcli"
                              name="codcli" maxlength="20" tabindex="6" />
                          </div>
                        </div>
                        <div *ngIf="tident == '06'">
                          <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Apellidos y nombres:
                            </label>
                            <div class="col-sm-8">
                              <input type="text" class="focus-input input_border form-control tsiInput"
                                [(ngModel)]="objProveedor.razonc" name="razonc"
                                (keyup)="onKeyUpNombresCompletos($event)" maxlength="75" tabindex="7" />
                            </div>
                            <span style="
                                color: red;
                                font: sans-serif;
                                margin-left: -17px;
                              ">(*)</span>
                          </div>
                        </div>
                        <div *ngIf="tident != '06'">
                          <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                            <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Razón social:
                            </label>
                            <div class="col-sm-8">
                              <input type="text" class="focus-input input_border form-control tsiInput"
                                [(ngModel)]="objProveedor.razonc" name="razonc" maxlength="75" tabindex="7" />
                            </div>
                            <span style="
                                color: red;
                                font: sans-serif;
                                margin-left: -17px;
                              ">(*)</span>
                          </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Dirección 1:
                          </label>
                          <div class="col-sm-8">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.direc1" name="direc1" maxlength="92" tabindex="8" />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Dirección 2:
                          </label>
                          <div class="col-sm-8">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.direc2" name="direc2" maxlength="92" tabindex="9" />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 text-left control-label">Apellido paterno:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.apellidopaterno" name="apellidopaterno" maxlength="20"
                              tabindex="10" />
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Correo electrónico:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.email" name="email" maxlength="40" tabindex="11" />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Apellido materno:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.apeliidomaterno" name="apeliidomaterno" maxlength="20"
                              tabindex="12" />
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Teléfono:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.telefono" name="telefono" maxlength="25" tabindex="13" />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Nombres:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.nombres" name="nombres" maxlength="20" tabindex="14" />
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Celular:
                          </label>
                          <div class="col-sm-3">
                            <input type="text" class="focus-input input_border form-control tsiInput"
                              [(ngModel)]="objProveedor.fax" name="fax" maxlength="25" tabindex="15" />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">DNI:
                          </label>
                          <div class="col-sm-3">
                            <input [disabled]="identidad" type="text"
                              class="focus-input input_border form-control tsiInput" [(ngModel)]="objProveedor.nrodni"
                              name="nrodni" maxlength="8" tabindex="16"
                              onkeypress="return event.charCode >= 8 && event.charCode <= 57" />
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2 ">Sexo:
                          </label>
                          <div class="col-sm-3">
                            <select tabindex="17" class=" col-sm-12 focus-input input_border  select_border tsiSelect"
                              id="sexo" name="sexo" [(ngModel)]="objProveedor.sexo">
                              <option value="M">Masculino</option>
                              <option value="F">Femenino</option>
                            </select>
                          </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2 ">Condición de pago:</label>
                          <div class="col-sm-3">
                            <select class="col-sm-12 focus-input input_border  select_border tsiSelect " id="objProveedor.codpag"
                              name="objProveedor.codpag" [(ngModel)]="objProveedor.codpag" tabindex="19">
                              <option *ngFor="let tit of condicionespago" value="{{ tit.codpag }}">
                                {{ tit.despag }}
                              </option>
                            </select>
                          </div>

                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Retenciones:
                          </label>
                          <div class="col-sm-3">
                            <select class="col-sm-12 focus-input input_border  select_border tsiSelect " id="objProveedor.regret"
                              name="objProveedor.regret" [(ngModel)]="objProveedor.regret" tabindex="20">
                              <option *ngFor="let lst of clienteRegimenes" value="{{ lst.codigo }}">
                                {{ lst.descri }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                          <label for="fname2" class="col-md-2 label-size tsiLabel mt-2">Comentario:
                          </label>
                          <div class="col-sm-8">
                            <input class="focus-input input_border tsiInput select_border form-control" id="repres"
                              name="repres" [(ngModel)]="objProveedor.repres" type="text" rows="6" maxlength="40"
                              tabindex="21" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>
                </ng-template>
              </ngb-tab>
            </ngb-tabset>

            <!-- Nuevo Ubigeo-->
            <ng-template #content3 let-modal> </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>